// Types
import { TCombinationRequiredFields } from "@/DataPages/components/CRM/SalesLeads/AddEditPopupDialog/types";
import { ICustomerAddress, IPhone, TConsentOption, TCustomerType } from "../../interfaces";

// Constants
import { INTERNET_TYPE } from "../constants";

// Helpers
import { isValidEmail } from "@/Common/helpers/Verifications/emails";

function isIndividual(type: TCustomerType) {
	return type === "individual";
}

function isTypeInternet(value: string) {
	return value === INTERNET_TYPE;
}

function isPropertyChildRight(object: Record<string, string>): boolean {
	return Object.entries(object).every(([key, value]) => key === value);
}

function isRequiredCombinationEmailPhonesAddress(combination: TCombinationRequiredFields) {
	const { address, email, phones } = combination;

	const validEmail = isValidEmail(email);
	const validPhones = areValidAllPhoneNumbers(phones);
	const validAddress = isAddressCompleted(address);

	const amountOfValidInputs = [validEmail, validPhones, validAddress].filter(Boolean)?.length;

	return amountOfValidInputs < 2;
}

function isAddressCompleted(address: ICustomerAddress) {
	const { address1 = "", city = "", state = "", country = "", zipCode = "" } = address;
	return [address1, city, state, country, zipCode].every(Boolean);
}

function isValidPhoneNumber(phone: string): boolean {
	/* Validate phone number that has at least +(##) ### | +## ###  */
	const regExp = /^\+\d+ (\d+|\(\d+\))/;
	return regExp.test(phone.toLowerCase());
}

function areValidAllPhoneNumbers(allPhoneNumbers: IPhone[]) {
	if (!allPhoneNumbers?.length) {
		return false;
	}

	return allPhoneNumbers.every((phone) => isValidPhoneNumber(phone.number));
}

function handleErrorEmail(params: TCombinationRequiredFields) {
	const isRequired = isRequiredCombinationEmailPhonesAddress(params);

	return isRequired ? !isValidEmail(params.email) : Boolean(params.email) ? !isValidEmail(params.email) : false;
}

function handleErrorPhones(params: TCombinationRequiredFields) {
	const isRequired = isRequiredCombinationEmailPhonesAddress(params);

	return isRequired ? !areValidAllPhoneNumbers(params.phones) : false;
}

function handleErrorAddress(params: TCombinationRequiredFields) {
	const isRequired = isRequiredCombinationEmailPhonesAddress(params);

	return isRequired ? !isAddressCompleted(params.address) : false;
}

function isConsentNull(value: TConsentOption) {
	return value === "Null";
}

export {
	isIndividual,
	isTypeInternet,
	isPropertyChildRight,
	isRequiredCombinationEmailPhonesAddress,
	isAddressCompleted,
	isValidPhoneNumber,
	areValidAllPhoneNumbers,
	handleErrorEmail,
	handleErrorPhones,
	handleErrorAddress,
	isConsentNull,
};
